export const METHODS = {
  POST: "POST",
  GET: "GET",
  DELETE: "DELETE",
  PUT: "PUT",
};

export const POST_HEADERS = {
  method: METHODS.POST,
  headers: {
    "Content-Type": "application/json",
  },
};

export const PUT_HEADERS = {
  method: METHODS.PUT,
  headers: {
    "Content-Type": "application/json",
  },
};

export const DELETE_HEADERS = {
  method: METHODS.DELETE,
  headers: {
    "Content-Type": "application/json",
  },
};

export const GET_HEADERS = {
  method: METHODS.GET,
  headers: {
    "Content-Type": "application/json",
  },
};
